function returnDiscount({ cost, discount, discountType }) {
    try {
        const costValue = Number(cost);
        const discountValue = Number(discount);

        if (discountType === 'flat') {
            return Number(discountValue)
        } else {
            let newDiscount = costValue * (discountValue / 100)
            return Number(newDiscount)
        }
    } catch (error) {
        throw error
    }
}

function returnDiscountedAmount({ cost, discount, discountType }) {
    try {
        if (discountType === 'flat') {
            return Number((+cost - +discount).toFixed(2))
        } else {
            let newDiscount = cost * (discount / 100)
            return Number((+cost - +newDiscount).toFixed(2))
        }
    } catch (error) {
        throw error
    }
}


function calculateMaterialCost(materialList) {
    let totalCost = 0;
    materialList?.data.forEach(mat => { totalCost += +returnDiscountedAmount({ cost: mat.cost, discount: mat.discount, discountType: mat.discountType }) });
    return Number(totalCost)

}

function calculateBundleCost(serviceBundle) {
    let totalCost = 0;
    serviceBundle?.data.forEach(bundle => { totalCost += +returnDiscountedAmount({ cost: bundle.cost, discount: bundle.discount, discountType: bundle.discountType }) });
    return Number(totalCost)
}

function calculateServiceCost(serviceList) {
    let totalCost = 0;
    serviceList?.data.forEach(service => service.costType === 'Fixed' && (totalCost += +returnDiscountedAmount({ cost: service.estimatedCost, discount: service.discount, discountType: service.discountType })));
    return Number(totalCost)
}

function calculateTotalTechnicianCost(serviceList, materialList, otherList, technicianCost) {
    let totalMinutes = 0;
    serviceList?.data?.forEach(data => totalMinutes += +data.estimatedTime);
    materialList?.data?.forEach(data => totalMinutes += +data.estimatedTime);
    otherList?.data?.forEach(data => totalMinutes += +data.estimatedTime);
    const result = (totalMinutes / 60)
    const totalTechnicianCost = (result * technicianCost).toFixed(2)
    return Number(totalTechnicianCost);
}

function calculateTotalTax(materialList, fromatedTaxRate) {
    const totalCost = Number(calculateMaterialCost(materialList));
    const tax = totalCost * fromatedTaxRate;
    return Number(tax.toFixed(2));
}

function calculateTotalCost(serviceList, materialList, otherList, serviceBundle, technicianCost, fromatedTaxRate) {
    const totalCost = calculateTotalTechnicianCost(serviceList, materialList, otherList, technicianCost) + calculateMaterialCost(materialList) + calculateBundleCost(serviceBundle) + calculateServiceCost(serviceList);
    return Number(totalCost.toFixed(2));
}

function calculateTotalFinalCost(totalCost, tax) {
    const total = (tax + totalCost).toFixed(2)
    return Number(total)
}

function calculateTotalDiscount(materialList, serviceList, serviceBundle) {
    let totalMaterialDiscount = 0;
    materialList?.data.forEach(mat => { totalMaterialDiscount += +returnDiscount({ cost: mat.cost, discount: mat.discount, discountType: mat.discountType }) });
    let totalServiceListDiscount = 0;
    serviceList?.data.forEach(service => service.costType === 'Fixed' && (totalServiceListDiscount += +returnDiscount({ cost: service.estimatedCost, discount: service.discount, discountType: service.discountType })));
    let totalServiceBundleDiscount = 0;
    serviceBundle?.data.forEach(mat => { totalServiceBundleDiscount += +returnDiscount({ cost: mat.cost, discount: mat.discount, discountType: mat.discountType }) });
    const totalDiscount = Number(totalMaterialDiscount) + Number(totalServiceListDiscount) + Number(totalServiceBundleDiscount);
    return totalDiscount;
}

function formatDate(isoDate) {
    if (!isoDate) {
        return ""
    }
    const [year, month, day] = isoDate.split("-");
    return `${month}-${day}-${year}`;
}

function formatToUSTime(timeStr) {
    const date = new Date(`1970-01-01T${timeStr}Z`);
    return date.toLocaleTimeString("en-US", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
    });
}


module.exports = {
    returnDiscount,
    returnDiscountedAmount,
    calculateMaterialCost,
    calculateBundleCost,
    calculateServiceCost,
    calculateTotalTechnicianCost,
    calculateTotalTax,
    calculateTotalCost,
    calculateTotalFinalCost,
    calculateTotalDiscount,
    formatDate,
    formatToUSTime
};